import { render } from "./SandboxJobDetail.vue?vue&type=template&id=e56883aa&scoped=true"
import script from "./SandboxJobDetail.vue?vue&type=script&lang=js"
export * from "./SandboxJobDetail.vue?vue&type=script&lang=js"

import "./SandboxJobDetail.vue?vue&type=style&index=0&id=e56883aa&scoped=true&lang=css"
import "./SandboxJobDetail.vue?vue&type=style&index=1&id=e56883aa&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e56883aa"]])

export default __exports__